import "./v31-patch.css";

const COGNITIVE_HEAD_SRC = "/assets/cognitive/cognitive-head-v3.webp";

// V5 cleanup: one faint registration plate + four non-overlapping depth fragments.
// At rest the portrait reads as one object; motion separates the fragments only subtly.
const LAYERS = [
  { cls: "cs-portrait-slab", depth: 24, x: -2, y: -2, clip: "polygon(8% 0, 92% 0, 92% 27%, 8% 27%)" },
  { cls: "cs-portrait-face", depth: 52, x: 2, y: 0, clip: "polygon(8% 27%, 92% 27%, 92% 55%, 8% 55%)" },
  { cls: "cs-portrait-neck", depth: 38, x: -1, y: 2, clip: "polygon(8% 55%, 92% 55%, 92% 76%, 8% 76%)" },
  { cls: "cs-portrait-ruin", depth: 62, x: 2, y: 2, clip: "polygon(8% 76%, 92% 76%, 92% 100%, 8% 100%)" },
];

export default function Monolith({ tension = 0.4 }) {
  const glow = 0.2 + tension * 0.42;
  return (
    <div data-testid="space-central-monolith" className="cs-portrait-shell cs-portrait-v5" style={{ position: "absolute", left: "50%", top: "50%", width: 430, height: 580, transform: "translate(-50%, -50%) translateZ(78px)", pointerEvents: "none", transformStyle: "preserve-3d" }}>
      <div className="cs-portrait-aura" style={{ opacity: glow, position: "absolute", inset: "-18%", transform: "translateZ(-110px)" }} />
      <div className="cs-portrait-shadow" />
      <div className="cs-portrait-fallback" aria-hidden="true"><span className="cs-fallback-head" /><span className="cs-fallback-slab a" /><span className="cs-fallback-slab b" /><span className="cs-fallback-slab c" /><span className="cs-fallback-neck" /></div>

      <div className="cs-portrait-registration" aria-hidden="true">
        <img src={COGNITIVE_HEAD_SRC} alt="" draggable="false" />
      </div>

      {LAYERS.map((layer, index) => (
        <div key={layer.cls} className={`cs-portrait-layer ${layer.cls}`} style={{ "--portrait-depth": `${layer.depth}px`, "--portrait-x": `${layer.x}px`, "--portrait-y": `${layer.y}px`, "--portrait-delay": `${index * -0.55}s`, clipPath: layer.clip }}>
          <img src={COGNITIVE_HEAD_SRC} alt="" draggable="false" onLoad={(e) => e.currentTarget.closest('.cs-portrait-shell')?.classList.add('has-portrait-image')} />
        </div>
      ))}

      <div className="cs-portrait-wire cs-portrait-wire-a" />
      <div className="cs-portrait-wire cs-portrait-wire-b" />
      <span className="cs-portrait-marker cs-portrait-marker-a" />
      <span className="cs-portrait-marker cs-portrait-marker-b" />
      <span className="cs-portrait-marker cs-portrait-marker-c" />
    </div>
  );
}
